import { ModalTypes } from '../../components/modals/residents/AllModals';
import { ADDDeviceResidentDTO, DeviceResidentDTO } from '../devices';
import { IBaseRule, RulesIds, assignAlertsBatchDTO } from '../residentRules/';
import { ResidentStatusesSocket } from '../residentStatuses';
import {
    AddResidentDTO,
    DisconnectAndEditDTO,
    EditResidentDTO,
    FallDetectedRuleSocket,
    MoveResidentWithDeviceDTO,
    MoveResidentWithDeviceResponceDTO,
    MoveResidentWithDevicesBySocketDTO,
    Resident,
    ResidentsSettings,
    changeNodePresenceDTO,
    changeNodePresenceSocket,
    defaultOptions,
    residentsReqOptions,
} from './';
import {
    IAddDeviceToResidentBySocket,
    IAddManyResidentFailure,
    IAddManyResidentRequest,
    IAddManyResidentSuccess,
    IAddResidentBySocket,
    IAddResidentDeviceFailure,
    IAddResidentDeviceRequest,
    IAddResidentDeviceSuccess,
    IAddResidentFailure,
    IAddResidentRequest,
    IAddResidentSuccess,
    IBatchDisconectAndChangeResidentsFailure,
    IBatchDisconectAndChangeResidentsRequest,
    IBatchDisconectAndChangeResidentsSuccess,
    IBatchResidentsPutFailure,
    IBatchResidentsPutRequest,
    IBatchResidentsPutSuccess,
    IChangeFakeRuleRequest,
    IChangeNodePresenceFailure,
    IChangeNodePresenceRequest,
    IChangeNodePresenceSocket,
    IChangeNodePresenceSuccess,
    IChangeResidentsSelected,
    IChangeRuleFailure,
    IChangeRuleRequest,
    IChangeRuleSuccess,
    IChangeRulesBatchFailure,
    IChangeRulesBatchRequest,
    IChangeRulesBatchSuccess,
    IDeleteBatchDevicesFromResidentsFailure,
    IDeleteBatchDevicesFromResidentsRequest,
    IDeleteBatchDevicesFromResidentsSuccess,
    IDeleteDeviceFromResidentBySocket,
    IDeleteManyResidentsFailure,
    IDeleteManyResidentsRequest,
    IDeleteManyResidentsSuccess,
    IDeleteResidentBySocket,
    IDeleteResidentDeviceFailure,
    IDeleteResidentDeviceRequest,
    IDeleteResidentDeviceSuccess,
    IDeleteResidentFailure,
    IDeleteResidentRequest,
    IDeleteResidentSuccess,
    IEditResidentFailure,
    IEditResidentRequest,
    IEditResidentSuccess,
    IGetFallDetectedRuleBySocket,
    IGetOneResidentFailure,
    IGetOneResidentRequest,
    IGetOneResidentSuccess,
    IGetResidentRulesFailure,
    IGetResidentRulesRequest,
    IGetResidentRulesSuccess,
    IGetResidentsFailure,
    IGetResidentsPicturesFailure,
    IGetResidentsPicturesRequest,
    IGetResidentsPicturesSuccess,
    IGetResidentsRequest,
    IGetResidentsStuffFailure,
    IGetResidentsStuffRequest,
    IGetResidentsStuffSuccess,
    IGetResidentsSuccess,
    IGetRuleFailure,
    IGetRuleRequest,
    IGetRuleSuccess,
    IMoveResidentWithDevicesBySoket,
    IMoveResidentWithDevicesFailure,
    IMoveResidentWithDevicesRequest,
    IMoveResidentWithDevicesSuccess,
    ISetResidentsSettings,
    IUpdateResidentBySocket,
    IUpdateResidentStatusesBySoket,
    RESIDENTS,
} from './types';
export function getResidents(options: residentsReqOptions, blocking = true): IGetResidentsRequest {
    return {
        type: RESIDENTS.GET_RESIDENTS_REQUEST,
        payload: { options: options !== undefined ? options : defaultOptions, blocking },
    };
}

export function getResidentsSussess(value: any[]): IGetResidentsSuccess {
    return { type: RESIDENTS.GET_RESIDENTS_SUCCESS, payload: value };
}

export function getResidentsFailure(value: any): IGetResidentsFailure {
    return { type: RESIDENTS.GET_RESIDENTS_FAILURE, payload: { value } };
}

export function addResident(dto: AddResidentDTO): IAddResidentRequest {
    return { type: RESIDENTS.ADD_RESIDENT_REQUEST, payload: dto };
}

export function addResidentSussess(value: any[]): IAddResidentSuccess {
    return { type: RESIDENTS.ADD_RESIDENT_SUCCESS, payload: value };
}

export function addResidentFailure(value: any): IAddResidentFailure {
    return { type: RESIDENTS.ADD_RESIDENT_FAILURE, payload: { value } };
}

export function addManyResident(value: AddResidentDTO[]): IAddManyResidentRequest {
    return { type: RESIDENTS.ADD_MANY_RESIDENT_REQUEST, payload: value };
}

export function addManyResidentSussess(value: any[]): IAddManyResidentSuccess {
    return { type: RESIDENTS.ADD_MANY_RESIDENT_SUCCESS, payload: value };
}

export function addManyResidentFailure(value: any): IAddManyResidentFailure {
    return { type: RESIDENTS.ADD_MANY_RESIDENT_FAILURE, payload: { value } };
}

export function getOneResidentInfo(residentID: string): IGetOneResidentRequest {
    return { type: RESIDENTS.GET_ONE_RESIDENT_REQUEST, payload: { residentId: residentID } };
}

export function getOneResidentInfoSussess(value: Resident): IGetOneResidentSuccess {
    return { type: RESIDENTS.GET_ONE_RESIDENT_SUCCESS, payload: value };
}

export function getOneResidentInfoFailure(value: any): IGetOneResidentFailure {
    return { type: RESIDENTS.GET_ONE_RESIDENT_FAILURE, payload: { value } };
}

export function changeRule(residentId: string, rule: IBaseRule): IChangeRuleRequest {
    return { type: RESIDENTS.CHANGE_RULE_REQUEST, payload: { residentId, rule } };
}

export function changeReducerRule(residentId: string, rule: IBaseRule): IChangeFakeRuleRequest {
    return { type: RESIDENTS.CHANGE_FAKE_RULE_REQUEST, payload: { residentId, rule } };
}
export function changeRuleSussess(value: any): IChangeRuleSuccess {
    return { type: RESIDENTS.CHANGE_RULE_SUCCESS, payload: value };
}

export function changeRuleFailure(value: any): IChangeRuleFailure {
    return { type: RESIDENTS.CHANGE_RULE_FAILURE, payload: value };
}

export function getResidentRule(residentId: string, rule: RulesIds): IGetRuleRequest {
    return { type: RESIDENTS.GET_RULE_REQUEST, payload: { residentId, rule } };
}

export function getResidentRuleSussess(residentId: string, rule: IBaseRule): IGetRuleSuccess {
    return { type: RESIDENTS.GET_RULE_SUCCESS, payload: { residentId, rule } };
}

export function getResidentRuleFailure(value: any): IGetRuleFailure {
    return { type: RESIDENTS.GET_RULE_FAILURE, payload: value };
}

export function geAllResidentRules(residentId: string): IGetResidentRulesRequest {
    return { type: RESIDENTS.GET_RESIDENT_RULES_REQUEST, payload: { residentId } };
}

export function geAllResidentRulesSussess(residentId: string, rules: IBaseRule[]): IGetResidentRulesSuccess {
    return { type: RESIDENTS.GET_RESIDENT_RULES_SUCCESS, payload: { residentId, rules } };
}

export function geAllResidentRulesFailure(value: any): IGetResidentRulesFailure {
    return { type: RESIDENTS.GET_RESIDENT_RULES_FAILURE, payload: value };
}

export function addResidentDevice(residentID: string, deviceId: string): IAddResidentDeviceRequest {
    return { type: RESIDENTS.ADD_DEVICE_REQUEST, payload: { residentID, deviceId } };
}

export function addResidentDeviceSussess(value: any): IAddResidentDeviceSuccess {
    return { type: RESIDENTS.ADD_DEVICE_SUCCESS, payload: value };
}

export function addResidentDeviceFailure(value: any): IAddResidentDeviceFailure {
    return { type: RESIDENTS.ADD_DEVICE_FAILURE, payload: { value } };
}

export function deleteResidentDevice(residentID: string, deviceId: string): IDeleteResidentDeviceRequest {
    return { type: RESIDENTS.DELETE_DEVICE_REQUEST, payload: { residentID, deviceId } };
}

export function deleteResidentDeviceSussess(value: any): IDeleteResidentDeviceSuccess {
    return { type: RESIDENTS.DELETE_DEVICE_SUCCESS, payload: value };
}

export function deleteResidentDeviceFailure(value: any): IDeleteResidentDeviceFailure {
    return { type: RESIDENTS.DELETE_DEVICE_FAILURE, payload: { value } };
}

export function editResident(dto: EditResidentDTO): IEditResidentRequest {
    return { type: RESIDENTS.EDIT_RESIDENT_REQUEST, payload: dto };
}

export function editResidentSussess(value: any): IEditResidentSuccess {
    return { type: RESIDENTS.EDIT_RESIDENT_SUCCESS, payload: value };
}

export function editResidentFailure(value: any): IEditResidentFailure {
    return { type: RESIDENTS.EDIT_RESIDENT_FAILURE, payload: { value } };
}

export function batchResidentsPut(value: {
    residents: EditResidentDTO[];
    isMoved: boolean;
}): IBatchResidentsPutRequest {
    return { type: RESIDENTS.BATCH_CHANGE_REQUEST, payload: value };
}

export function batchResidentsPutSussess(value: any): IBatchResidentsPutSuccess {
    return { type: RESIDENTS.BATCH_CHANGE_SUCCESS, payload: value };
}

export function batchResidentsPutFailure(value: any): IBatchResidentsPutFailure {
    return { type: RESIDENTS.BATCH_CHANGE_FAILURE, payload: { value } };
}

export function deleteResident(residentId: string): IDeleteResidentRequest {
    return { type: RESIDENTS.DELETE_RESIDENT_REQUEST, payload: { residentId } };
}

export function deleteResidentSussess(value: any): IDeleteResidentSuccess {
    return { type: RESIDENTS.DELETE_RESIDENT_SUCCESS, payload: value };
}

export function deleteResidentFailure(value: any): IDeleteResidentFailure {
    return { type: RESIDENTS.DELETE_RESIDENT_FAILURE, payload: { value } };
}

export function deleteManyDevicesFromResidents(value: DeviceResidentDTO[]): IDeleteBatchDevicesFromResidentsRequest {
    return { type: RESIDENTS.DELETE_BATCH_DEVICE_REQUEST, payload: value };
}

export function deleteManyDevicesFromResidentsSuccess(
    value: DeviceResidentDTO[],
): IDeleteBatchDevicesFromResidentsSuccess {
    return { type: RESIDENTS.DELETE_BATCH_DEVICE_SUCCESS, payload: value };
}

export function deleteDeviceFromResidentBySocket(value: DeviceResidentDTO): IDeleteDeviceFromResidentBySocket {
    return { type: RESIDENTS.DELETE_DEVICE_FROM_RESIDENT_BYSOCKET, payload: value };
}
export function addDeviceToResidentBySocket(value: ADDDeviceResidentDTO): IAddDeviceToResidentBySocket {
    return { type: RESIDENTS.ADD_DEVICE_TO_RESIDENT_BY_SOCKET, payload: value };
}

export function deleteManyDevicesFromResidentsFailure(value: any): IDeleteBatchDevicesFromResidentsFailure {
    return { type: RESIDENTS.DELETE_BATCH_DEVICE_FAILURE, payload: value };
}

export function deleteManyResidents(value: string[]): IDeleteManyResidentsRequest {
    return { type: RESIDENTS.DELETE_MANY_RESIDENTS_REQUEST, payload: value };
}

export function deleteManyResidentsSuccess(value: string[]): IDeleteManyResidentsSuccess {
    return { type: RESIDENTS.DELETE_MANY_RESIDENTS_SUCCESS, payload: value };
}

export function deleteManyResidentsFailure(value: any): IDeleteManyResidentsFailure {
    return { type: RESIDENTS.DELETE_MANY_RESIDENTS_FAILURE, payload: value };
}

export function moveResidentWithDevices(value: MoveResidentWithDeviceDTO): IMoveResidentWithDevicesRequest {
    return { type: RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_REQUEST, payload: value };
}
export function moveResidentWithDevicesSuccess(
    value: MoveResidentWithDeviceResponceDTO[],
): IMoveResidentWithDevicesSuccess {
    return { type: RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_SUCCESS, payload: value };
}
export function moveResidentWithDevicesFailure(value: any): IMoveResidentWithDevicesFailure {
    return { type: RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_FAILURE, payload: value };
}

export function batchDisconnectAndChangeResidents(
    value: DisconnectAndEditDTO[],
    reason: ModalTypes,
): IBatchDisconectAndChangeResidentsRequest {
    return { type: RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_REQUEST, payload: { data: value, reason: reason } };
}

export function batchDisconnectAndChangeResidentsSuccess(
    value: DisconnectAndEditDTO[],
): IBatchDisconectAndChangeResidentsSuccess {
    return { type: RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_SUCCESS, payload: value };
}

export function batchDisconnectAndChangeResidentsFailure(value: any): IBatchDisconectAndChangeResidentsFailure {
    return { type: RESIDENTS.BATCH_DISCONNECT_AND_CHANGE_FAILURE, payload: value };
}

export function setResidentsSettings(value: ResidentsSettings): ISetResidentsSettings {
    return { type: RESIDENTS.SET_SETTINGS, payload: value };
}

export function deleteResidentBySoket(value: { id: string; nodeId: number }): IDeleteResidentBySocket {
    return { type: RESIDENTS.DELETE_RESIDENT_BY_SOCKET, payload: value };
}

export function addResidentBySoket(value: Resident): IAddResidentBySocket {
    return { type: RESIDENTS.ADD_RESIDENT_BY_SOCKET, payload: value };
}

export function updateResidentBySoket(value: Resident): IUpdateResidentBySocket {
    return { type: RESIDENTS.UPDATE_RESIDENT_BY_SOCKET, payload: value };
}

export function updateFallDetectedResidentRuleBySocket(value: FallDetectedRuleSocket): IGetFallDetectedRuleBySocket {
    return { type: RESIDENTS.UPDATE_FALL_DETECTED_RULE_BY_SOCKET, payload: value };
}

export function moveResidentWithDevicesBySocket(
    value: MoveResidentWithDevicesBySocketDTO,
): IMoveResidentWithDevicesBySoket {
    return { type: RESIDENTS.MOVE_RESIDENT_WITH_DEVICES_BY_SOCKET, payload: value };
}

export function changeResidentsSelected(value: string): IChangeResidentsSelected {
    return { type: RESIDENTS.CHANGE_SELECTED, payload: value };
}

export function updateResidentStatusesBySoket(value: ResidentStatusesSocket): IUpdateResidentStatusesBySoket {
    return { type: RESIDENTS.UPDATE_STATUSES_BY_SOCKET, payload: value };
}

export function getResidentsPictures(): IGetResidentsPicturesRequest {
    return { type: RESIDENTS.GET_RESIDENTS_PICTURES_REQUEST };
}

export function getResidentsPicturesSussess(value: any[]): IGetResidentsPicturesSuccess {
    return { type: RESIDENTS.GET_RESIDENTS_PICTURES_SUCCESS, payload: value };
}

export function getResidentsPicturesFailure(value: any): IGetResidentsPicturesFailure {
    return { type: RESIDENTS.GET_RESIDENTS_PICTURES_FAILURE, payload: value };
}

export function getResidentsRulesAlertsStatuses(): IGetResidentsStuffRequest {
    return { type: RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_REQUEST };
}

export function getResidentsRulesAlertsStatusesSussess(value: any[]): IGetResidentsStuffSuccess {
    return { type: RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_SUCCESS, payload: value };
}

export function getResidentsRulesAlertsStatusesFailure(value: any): IGetResidentsStuffFailure {
    return { type: RESIDENTS.GET_RESIDENTS_RULES_ALERTS_STATUSES_FAILURE, payload: value };
}

export function changeResidentStatusBatch(dto: changeNodePresenceDTO): IChangeNodePresenceRequest {
    return { type: RESIDENTS.CHANGE_NODE_PRESENCE_REQUEST, payload: dto };
}

export function changeStatusBatchBySocket(dto: changeNodePresenceSocket): IChangeNodePresenceSocket {
    return { type: RESIDENTS.CHANGE_NODE_PRESENCE_BY_SOCKET, payload: dto };
}
export function changeStatusBatchSussess(value: any): IChangeNodePresenceSuccess {
    return { type: RESIDENTS.CHANGE_NODE_PRESENCE_SUCCESS, payload: value };
}
export function changeStatusBatchFailure(value: any): IChangeNodePresenceFailure {
    return { type: RESIDENTS.CHANGE_NODE_PRESENCE_FAILURE, payload: value };
}

export function changeResidentsRulesBatch(dto: assignAlertsBatchDTO): IChangeRulesBatchRequest {
    return { type: RESIDENTS.CHANGE_RULES_BATCH_REQUEST, payload: dto };
}

// export function changeResidentsRulesBatchSocket(dto: changeNodePresenceSocket): IChangeRulesBatchSuccess {
//     return { type: RESIDENTS.CHANGE_NODE_PRESENCE_BY_SOCKET, payload: dto };
// }
export function changeResidentsRulesBatchSussess(dto: assignAlertsBatchDTO): IChangeRulesBatchSuccess {
    return { type: RESIDENTS.CHANGE_RULES_BATCH_SUCCESS, payload: dto };
}
export function changeResidentsRulesBatchFailure(value: any): IChangeRulesBatchFailure {
    return { type: RESIDENTS.CHANGE_RULES_BATCH_FAILURE, payload: value };
}
